import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AUTH_API_ENDPOINTS } from '../auth/consts/auth.constants';
import { API_PREFIX } from '../consts/general.constants';
import { OnboardingResponse } from '../../shared/interfaces/onboarding.inteerface';
import { Dialog } from '@angular/cdk/dialog';
import { OnboardingComponent } from '../../features/onboarding/onboarding.component';
import { Router } from '@angular/router';
import { APP_FULL_PATHS } from '../../shared/constants/routes.constants';

@Service()
export class OnboardingService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly fullApiUrl = `${this.baseUrl}${API_PREFIX}`;

  private readonly dialog = inject(Dialog);
  private http = inject(HttpClient);
  private router = inject(Router);

  public checkOnboarding(): Observable<OnboardingResponse | null> {
    return this.http
      .get<OnboardingResponse | null>(`${this.fullApiUrl}${AUTH_API_ENDPOINTS.onboarding}`)
      .pipe(
        tap((data) => {
          this.router.navigate([APP_FULL_PATHS.DASHBOARD]);
          if (data) {
            this.dialog.open<string, OnboardingResponse>(OnboardingComponent, { data: data });
          }
        }),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public onboardingComplete(): Observable<void> {
    return this.http.put<void>(`${this.fullApiUrl}${AUTH_API_ENDPOINTS.onboardingComplete}`, null);
  }
}
